import { ButtonTriggerEvent } from '../../../../common/components';
import { Account } from '../../../../models/admin/account';

export class TravelBuddyConversationsModalActions {
  confirm: (event: ButtonTriggerEvent) => void;
  cancel?: () => void;
}

export class TravelBuddyConversationsModalData {}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/travel.buddy.conversations/travel.buddy.conversations.modal.provider.ts